module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg1-846ade4a9126d8291907fc3935d8ad4e.jpg";